import { useEffect } from 'react';

import Cookies from 'js-cookie';
import { useRouter } from 'next/router';

import { ServiceOSGlobalSettings } from '../utils/getServiceOSGlobalSettings';
import { ServiceOSApiClient } from '../utils/serviceOSApiClient';
import { SERVICE_OS_API_AUTH_COOKIE_NAME } from '../utils/serviceOSAxiosClient';

const serviceOSApiClient = new ServiceOSApiClient();

export function useServiceOSFountainRedirects(serviceOSGlobalSettings: ServiceOSGlobalSettings) {
  const router = useRouter();

  const urlMatch =
    serviceOSGlobalSettings?.redirectToFountainFrom?.find((url) =>
      `${router.locale}${router.asPath}`.includes(url)
    ) || null;

  const generateFountainLink = async () => {
    const { data } = await serviceOSApiClient.generateFountainLink();

    if (data && data.portal_url) {
      window.location = data.portal_url;
    } else {
      if (urlMatch !== serviceOSGlobalSettings.loginPageUrl) {
        void router.push(serviceOSGlobalSettings.loginPageUrl);
      }
    }
  };

  useEffect(() => {
    const sid = Cookies.get(SERVICE_OS_API_AUTH_COOKIE_NAME) || null;

    if (sid && (!!urlMatch || serviceOSGlobalSettings?.redirectToFountainFrom?.length === 0)) {
      void generateFountainLink();
    }
  }, []);
}
